import React, { Component } from "react";
import { Row, Col, Alert, InputGroup, InputGroupText } from "reactstrap";

import { FetchData } from "../utils/DataFetch";
import { GetCookie } from "../utils/Common";
import {
  RptClientInvoiceSummaryTableDefault,
  columns as rptClientInvoiceSummaryColumns,
} from "./RptClientInvoiceSummaryTableDefault";
import { exportRowsToExcel } from "../utils/ReportExport";
import { ExcelExportButton } from "./ExcelExportButton";

export class RptClientInvoiceSummary extends Component {
  static displayName = RptClientInvoiceSummary.name;

  constructor(props) {
    super(props);
    this.state = {
      rptClientInvoiceSummaryList: [],
      jobCount: 0,
      loading: false,
      fetchingData: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      searchModel: {
        ClientAbbrv: "",
        StartDate: "",
        EndDate: "",
      },
    };
    this.user = JSON.parse(GetCookie("user"));
    this.clickCount = 0;
    this.singleClickTimer = "";

    this.renderRptClientInvoiceSummaryTable =
      this.renderRptClientInvoiceSummaryTable.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.exportClientInvoiceSummary = this.exportClientInvoiceSummary.bind(this);
    //
  }

  componentDidMount() {
    //this.populateRolodexData();

    document.onmousemove = this.handleOnMouseMove;
    document.onmouseup = this.handleOnMouseUp;
    return () => {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateRptClientInvoiceSummaryData();
    }
  }

  async populateRptClientInvoiceSummaryData() {
    this.setState({ fetchingData: true });

    FetchData(
      "/getrptclientinvoicesummary",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({
        rptClientInvoiceSummaryList: data,
        loading: false,
        fetchingData: false,
      });
    });
  }

  exportClientInvoiceSummary() {
    exportRowsToExcel({
      rows: this.state.rptClientInvoiceSummaryList,
      columns: rptClientInvoiceSummaryColumns,
      fileName: "ClientInvoiceSummaryReport.xlsx",
    });
  }

  renderRptClientInvoiceSummaryTable(rptClientInvoiceSummary) {
    return (
      <RptClientInvoiceSummaryTableDefault
        rptClientInvoiceSummary={this.state.rptClientInvoiceSummaryList}
        state={this.state}
      ></RptClientInvoiceSummaryTableDefault>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRptClientInvoiceSummaryTable(
        this.state.rptClientInvoiceSummaryList
      )
    );

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Client Invoice Summary Report</h5>
        <Row className="align-items-center g-2">
          <Col className="col-4">
            <InputGroup size="sm">
              <input
                name="ClientAbbrv"
                ref={(input) => {
                  this.ClientAbbrv = input;
                }}
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.ClientAbbrv}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                placeholder="Client Abbrv"
                onKeyDown={this.handleKeyDown}
              />
              <InputGroupText>Start Date</InputGroupText>
              <input
                name="StartDate"
                ref={(ref) => (this.txtStartDate = ref)}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.StartDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="Start Date"
                onKeyDown={this.handleKeyDown}
              />
              <InputGroupText>End Date</InputGroupText>
              <input
                name="EndDate"
                ref={(input) => {
                  this.EndDate = input;
                }}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.EndDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="End Date"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
          <Col className="col-auto">
            <InputGroup size="sm">
              <ExcelExportButton
                onClick={this.exportClientInvoiceSummary}
                title="Export Client Invoice Summary Report"
              />
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <div>{contents}</div>
      </div>
    );
  }
}
